<template>
  <div class="currency_input form-group">
    <label v-if="label">
      {{ label }}<br>
    </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span
          class="input-group-text"
          v-html="currencySymbol"
        />
      </div>
      <input
        type="text"
        :class="[
          'form-control',
          errorString ? 'text-danger' : '',
        ]"
        placeholder="0.00"
        :value="displayPrice"
        @change.stop="$emit('change', $event.target.value.replace(/[A-Za-z!@#$%^&*(),]/g, ''))"
      >
    </div>
    <small
      v-if="errorString"
      class="text-danger"
      v-html="errorString+'<br>'"
    />
    <small
      v-if="message"
      :class="[
        message ? 'has_message' : '',
        'min_message',
      ]"
      @click="showMinimumBreakdown"
    >
      {{ message }}
      <span
        title="Click for more information"
        v-html="
          minimumPriceString !== ''
            ? currencySymbol+minimumPriceString
            : ''
        "
      />
    </small>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  props: {
    isSupportProduct: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    priceInPence: {
      type: Number,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: '',
    },
    currencySymbol: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    minimumPriceData: {
      type: Object,
      default: function () {
        return {
          minimum: 0,
        };
      },
    },
    errorString: {
      type: String,
      default: '',
    },
    messagePopupContent: {
      type: String,
      default: null,
    },
  },
  emits: [
    'change',
  ],
  computed: {
    displayPrice() {
      if (isNaN(this.priceInPence)) {
        return '0.00'
      }

      return (this.priceInPence / 100).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
      });
    },
    minimumPriceString() {
      if (this.minimumPriceData.minimum === 0) {
        return '';
      }

      let breakdown = '';

      if (this.minimumPriceData.stripe_fees) {
        const wholesalePriceFormatted = (this.minimumPriceData.price / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 2,
        })
        const stripeFeesFormatted = (this.minimumPriceData.stripe_fees / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 2,
        })
        breakdown += '<br>('+
          `Hike cost: ${this.currencySymbol}${wholesalePriceFormatted} + `+
          `Stripe fees: ${this.currencySymbol}${stripeFeesFormatted}`+
        ')';
      }

      return (this.minimumPriceData.minimum / 100).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
      }) + breakdown;
    },
  },
  methods: {
    showMinimumBreakdown() {
      if (this.messagePopupContent) {
        Swal.fire({
          icon: 'info',
          html: this.messagePopupContent,
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: .5rem;
}

.input-group {
  .input-group-prepend {
    background: #FBFAFA;

    .input-group-text {
      border-top-left-radius: 12px !important;
      border-bottom-left-radius: 12px !important;
      font-weight: 500;
      color: #040707;
    }
  }
  .form-control {
    border-radius: 0 12px 12px 0;
    border-left: 0;
    margin: 0;
    padding: 0 0 0 0.5rem;
    min-height: 46px;
  }
}

label {
  font-weight: 500;
  font-size: 1.125rem;
}

.text-danger {
  margin-bottom: 1rem;
}

.min_message {

  &.has_message {
    cursor: help;
  }

  span {
    text-decoration: underline;
    color: #0c7bbe;
  }
}
</style>
